import { Injectable } from '@angular/core';
import { NgxPendoService } from 'ngx-pendo';

import { environment } from '®environments/environment';
import { AppConfig } from '®shared/config';

import { CurrentUserAndPermissions } from '../current-user';
import { UserInstitutionalRole } from '../user';

declare const pendo: any;

@Injectable()
export class PendoService {
  constructor(
    private appConfig: AppConfig,
    private ngxPendoService: NgxPendoService,
  ) {}

  /**
   * Proxy through to NgxPendoService's initialize()
   */
  public initialize(user: CurrentUserAndPermissions): void {
    if (!environment.production) {
      return;
    }

    if (!this.isQualifyingUser(user)) {
      return;
    }

    const tenantCode = this.appConfig.tenant.shortCode;

    const userData = {
      id: user.oauthUser.guid,
      name: user.oauthUser.fullName,
      aspireRole: user.tarlUser.institutionalRole,
    };

    const accountData = {
      id: tenantCode,
    };

    if (typeof pendo !== 'undefined' && pendo) {
      this.ngxPendoService.initialize(userData, accountData);
    }
  }

  private isQualifyingUser(user: CurrentUserAndPermissions): boolean {
    if (!user.hasTarlAccount) {
      return false;
    }

    if (
      !user.tarlUser?.institutionalRole ||
      user.tarlUser.institutionalRole === UserInstitutionalRole.STUDENT
    ) {
      // Only record students whose GUID ends with '[0-9]w' to randomly sample
      if (!user.oauthUser.guid.match(/\dw$/)) {
        return false;
      }
    }

    return true;
  }
}
